import { useCallback, useMemo } from 'react';
import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useSendCrmMessageTopic } from 'crm-message-bus/useSendCrmMessageTopic';
import { Link } from 'foundations-components/transitional/components/Link';
import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import formatFriendlyName from 'I18n/utils/formatFriendlyName';
import { useGetDataSharingSourceAccountsQuery } from '../../__generated__/chirp/com/hubspot/multi/account/configuration/manager/rpc/MultiAccountConnectionsChirpService.hooks';
import { useGetContactDetails } from '../hooks/useGetContactDetails';
import { useGetIsConnectedContact } from '../hooks/useGetIsConnectedContact';
import { ErrorBoundary } from './ErrorBoundary';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function MultiAccountContact({
  contactId
}) {
  const openPanelMessage = useSendCrmMessageTopic(TOPIC_NAMES.OPEN_MULTI_ACCOUNT_PANEL);
  const openPanel = useCallback((portalId, objectId) => {
    return openPanelMessage({
      portalId,
      objectId,
      objectTypeId: '0-1'
    });
  }, [openPanelMessage]);
  const {
    data: dataSharingSourceAccountsData,
    loading: dataSharingSourceAccountsLoading
  } = useGetDataSharingSourceAccountsQuery();
  const sharedPortalId = dataSharingSourceAccountsData === null || dataSharingSourceAccountsData === void 0 ? void 0 : dataSharingSourceAccountsData.dataSharingSourceAccountIds[0];
  const {
    isConnectedContact,
    loading: isConnectedContactLoading
  } = useGetIsConnectedContact(contactId, {
    skip: !sharedPortalId
  });
  const {
    loading: contactDetailsLoading,
    contactDetailsData
  } = useGetContactDetails(contactId, {
    skip: !sharedPortalId || !isConnectedContact
  });
  const contactName = useMemo(() => {
    var _contactDetailsData$p, _contactDetailsData$p2;
    if (!contactDetailsData) {
      return '';
    }
    return formatFriendlyName({
      givenName: (_contactDetailsData$p = contactDetailsData.properties) === null || _contactDetailsData$p === void 0 || (_contactDetailsData$p = _contactDetailsData$p.firstname) === null || _contactDetailsData$p === void 0 ? void 0 : _contactDetailsData$p.value,
      familyName: (_contactDetailsData$p2 = contactDetailsData.properties) === null || _contactDetailsData$p2 === void 0 || (_contactDetailsData$p2 = _contactDetailsData$p2.lastname) === null || _contactDetailsData$p2 === void 0 ? void 0 : _contactDetailsData$p2.value
    });
  }, [contactDetailsData]);
  if (dataSharingSourceAccountsLoading || isConnectedContactLoading || contactDetailsLoading) {
    return null;
  }
  if (!sharedPortalId) {
    return null;
  }
  if (!isConnectedContact) {
    return null;
  }
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    children: [/*#__PURE__*/_jsx(StatusDot, {
      use: "success"
    }), contactName !== '' ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "multi-account-crm-panel-lib.contact_jsx",
      options: {
        name: contactName,
        onClick: () => openPanel(sharedPortalId, contactId),
        'data-test-id': 'connected-contact-link'
      },
      elements: {
        Link
      }
    }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "multi-account-crm-panel-lib.noNameContact_jsx",
      elements: {
        Link
      },
      options: {
        onClick: () => openPanel(sharedPortalId, contactId)
      }
    })]
  });
}